import React, {useEffect, useState} from "react";
import adminService from "../services/admin.service";
import ClientDiscountItem from "./ClientDiscountItem";
import {clearMessage} from "../slices/message";
import {useDispatch} from "react-redux";
import * as ClientFilter from "./ClientFilter";

const ClientDiscount = () => {
  const [clients, setClients] = useState([]);
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const dispatch = useDispatch();
  const [filterName, setFilterName] = useState("");
  const [filterAddress, setFilterAddress] = useState("");
  const [filterCity, setFilterCity] = useState("");
  const [filterOwner, setFilterOwner] = useState("");
  const [displayClients, setDisplayClients] = useState([]);
  let timeout;

  useEffect(() => {
    dispatch(clearMessage());
  }, [dispatch]);


  useEffect(() => {
    setLoading(true);

      adminService.getClients().then(
          (response) => {
              setClients(response.data);
              setDisplayClients(response.data);
              setLoading(false);
          },
          (error) => {
              const _content =
                  (error.response &&
                      error.response.data) ||
                  error.message ||
                  error.toString();
              console.log(error);

              setMessage(_content);
              setLoading(false);
          }
      );

  }, []);

  useEffect(() => {
    setLoading(true);

      adminService.getDiscountSub().then(
          (response) => {
              setSubs(response.data);
              setLoading(false);
          },
          (error) => {
              const _content =
                  (error.response &&
                      error.response.data) ||
                  error.message ||
                  error.toString();
              console.log(error);

              setMessage(_content);
              setLoading(false);
          }
      );

  }, []);

  const handleFilterNameChange = (event) => {
      ClientFilter.handleFilterChange(event.target.value, [setFilterName], [setFilterAddress, setFilterCity, setFilterOwner], timeout, (c) => c.clientName.toLowerCase().includes(event.target.value.toLowerCase()), clients, setDisplayClients);
  }

  const handleFilterOwnerChange = (event) => {
      ClientFilter.handleFilterChange(event.target.value, [setFilterOwner], [setFilterName, setFilterAddress, setFilterCity], timeout, (c) => c.email.toLowerCase().includes(event.target.value.toLowerCase()), clients, setDisplayClients);
  }

  const handleFilterAddressChange = (event) => {
      ClientFilter.handleFilterChange(event.target.value, [setFilterAddress], [setFilterName, setFilterCity, setFilterOwner], timeout, (c) => c.address.toLowerCase().includes(event.target.value.toLowerCase()), clients, setDisplayClients);
  }

  const handleFilterCityChange = (event) => {
      ClientFilter.handleFilterChange(event.target.value, [setFilterCity], [setFilterName, setFilterAddress, setFilterOwner], timeout, (c) => c.city.toLowerCase().includes(event.target.value.toLowerCase()), clients, setDisplayClients);
  }

  return (
      <div className="container-fluid py-4" style={{ background: 'var(--bg-gradient)', minHeight: 'calc(100vh - 76px)' }}>
        <div className="card border-0 shadow-lg rounded-4 overflow-hidden mb-4">
          <div className="card-header bg-white border-0 py-3 px-4 d-flex align-items-center justify-content-between">
            <h5 className="mb-0 fw-bold text-dark d-flex align-items-center">
              <i className="bi bi-tags text-primary me-2 fs-4"></i>
              Set Client Discount
            </h5>
            {loading && (
              <span className="spinner-border spinner-border-sm text-primary"></span>
            )}
          </div>
          
          {message && (
              <div className="px-4 pt-2">
                <div className="alert alert-danger border-0 shadow-sm rounded-3 d-flex align-items-center" role="alert">
                  <i className="bi bi-exclamation-triangle-fill me-2 fs-5"></i>
                  <div>{message}</div>
                </div>
              </div>
          )}
          
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light">
                <tr>
                  <th scope="col" className="text-secondary fw-semibold py-3 ps-4">Name</th>
                  <th scope="col" className="text-secondary fw-semibold py-3">Owner</th>
                  <th scope="col" className="text-secondary fw-semibold py-3">Address</th>
                  <th scope="col" className="text-secondary fw-semibold py-3">City</th>
                  <th scope="col" className="text-secondary fw-semibold py-3">Subscription</th>
                  <th scope="col" className="text-secondary fw-semibold py-3 pe-4">Discount</th>
                  <th scope="col" className="text-secondary fw-semibold py-3">Action</th>
                </tr>
                </thead>
                <tbody className="border-top-0">
                <tr className="bg-light bg-opacity-50">
                    <td className="ps-4"><input type="text" className="form-control form-control-sm bg-white border-0 shadow-sm" placeholder="Filter..." value={filterName} onChange={handleFilterNameChange} /></td>
                    <td><input type="text" className="form-control form-control-sm bg-white border-0 shadow-sm" placeholder="Filter..." value={filterOwner} onChange={handleFilterOwnerChange} /></td>
                    <td><input type="text" className="form-control form-control-sm bg-white border-0 shadow-sm" placeholder="Filter..." value={filterAddress} onChange={handleFilterAddressChange} /></td>
                    <td><input type="text" className="form-control form-control-sm bg-white border-0 shadow-sm" placeholder="Filter..." value={filterCity} onChange={handleFilterCityChange} /></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            {displayClients && displayClients.length > 0 && subs && subs.length > 0 && displayClients.map((c, index) => (
                <ClientDiscountItem key={c.oid} item={c} subs={subs}/>
            ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

  );
};

export default ClientDiscount;
